import { Project } from '@ts-intl/shared';
import { getPatternByArr, ignoreCallNames, ignoreCSSProperties, ignoreCSSTexts, ignoreCustomProperties, ignoreFiles, ignoreIndexNames, ignoreReservedWords, ignoreUrlPatterns, matchedJSXAttrs, matchedPattern, } from './config';
export const getNoRawRule = ({ rootDir, entry, }, configs) => {
    var _a, _b;
    const project = Project.getSingleton(rootDir);
    return {
        rules: {
            '@ts-intl/ts-intl/no-raw-text': [
                'warn',
                Object.assign(Object.assign({}, project.projectConfig.integration), { include: {
                        body: entry,
                    }, exclude: [
                        {
                            body: [...ignoreFiles, ...((_a = configs === null || configs === void 0 ? void 0 : configs.ignoreFiles) !== null && _a !== void 0 ? _a : [])].join('|'),
                        },
                    ], matchedPattern: (_b = configs === null || configs === void 0 ? void 0 : configs.matchedPattern) !== null && _b !== void 0 ? _b : matchedPattern, autoFill: Object.assign(Object.assign({}, configs === null || configs === void 0 ? void 0 : configs.autoFill), { rootDir }), ignoreNodes: [
                        {
                            type: 'JSXAttribute',
                            body: getPatternByArr(matchedJSXAttrs, configs === null || configs === void 0 ? void 0 : configs.matchedJSXAttrs, true),
                            flags: 'i',
                        },
                        {
                            type: 'Property',
                            body: getPatternByArr(ignoreCustomProperties, configs === null || configs === void 0 ? void 0 : configs.ignoreCustomProperties),
                            flags: 'i',
                        },
                        {
                            type: 'Property',
                            body: getPatternByArr(ignoreCSSProperties, configs === null || configs === void 0 ? void 0 : configs.ignoreCSSProperties),
                        },
                        {
                            type: 'Property,VariableDeclarator,AssignmentPattern',
                            body: getPatternByArr(ignoreIndexNames, configs === null || configs === void 0 ? void 0 : configs.ignoreIndexNames),
                            flags: 'i',
                        },
                        {
                            type: 'CallExpression',
                            body: getPatternByArr(ignoreCallNames, configs === null || configs === void 0 ? void 0 : configs.ignoreCallNames),
                        },
                    ], ignoreTexts: [
                        {
                            body: getPatternByArr(ignoreCSSTexts, configs === null || configs === void 0 ? void 0 : configs.ignoreCSSTexts),
                        },
                        {
                            body: getPatternByArr(ignoreReservedWords, configs === null || configs === void 0 ? void 0 : configs.ignoreReservedWords),
                        },
                        {
                            body: getPatternByArr(ignoreUrlPatterns, configs === null || configs === void 0 ? void 0 : configs.ignoreUrlPatterns),
                        },
                    ] }),
            ],
        },
    };
};
